const getEnv = () => {
	const w = window.innerWidth;
	let env: string;
	if (w <= 1280 && w > 767) {
		env = `tablette`;
	} else if (w <= 767) {
		env = `mobile`;
	} else {
		env = `desktop`;
	}
	return env;
};

getEnv();

/**
 * @description Animation au scroll
 */

(() => {
	/**
	 * @description La class-selector est à définir côté twig
	 * @constant scrollElements Global Anime selector
	 */
	const scrollElements = document.querySelectorAll(`.js-scroll`) || null;

	/**
	 * @description La class-selector est à définir côté twig
	 * @constant scrollElementsPres Anime selector bloc presentation
	 */
	const scrollElementsPres =
		document.querySelectorAll(`.js-scroll-pres`) || null;

	/**
	 * @description Détection lorsqu'un élément est en vue
	 * @param {HTMLELement} el Element - "class-selector"
	 * @param {*} divH Définit la hauteur de l'élément au moment ou l'anime est déclenchée
	 * @method getBoundingClientRect Méthode permettant d'obtenir la distance d'un élément par rapport au haut de la page
	 * @property {number} innerHeight Permet de récupèrer la hauteur de la fenêtre
	 * @property {number} clientHeight Permet de récupèrer la hauteur de la fenêtre
	 * @returns L'élément au moment du scroll
	 */
	const elementInView = (el: HTMLElement, divH = 1) => {
		const elementTop = el.getBoundingClientRect().top;

		return (
			elementTop <=
			(window.innerHeight || document.documentElement.clientHeight) / divH
		);
	};

	/**
	 * @description Détection lorsqu'un élément est en dehors de la vue
	 * @param {*} el Element
	 * @return {*} Permet de déclencher à nouveau l'anime quand l'élément est déjà scrollé
	 */
	const elementOutofView = (el: HTMLElement) => {
		const elementTop = el.getBoundingClientRect().top;

		return (
			elementTop >
			(window.innerHeight || document.documentElement.clientHeight)
		);
	};

	/**
	 * @description Ajoute la class "scrolled" lorsque l'élément est dans la vue
	 */
	const displayScrollElement = (element: HTMLElement) => {
		element.classList.add(`scrolled`);
	};

	/**
	 * @description Retire la class "scrolled" lorsque l'élément n'est plus dans la vue
	 * Cela permet de re-déclencher l'animation lorsque l'élément sera à nouveau scrollé
	 */
	const hideScrollElement = (element: HTMLElement) => {
		element.classList.remove(`scrolled`);
	};

	/**
	 * @description Déclencheur au scroll
	 * La seule chose à modifier ici est le second paramétre "divH" :
	 * À ajuster pour déclencher l'event au moment voulu lors du scroll.
	 * Le fait de boucler la/les "class-selector" permet d'appliquer
	 * les différentes méthodes sur l'ensemble des éléments
	 * @example La condition pour chaque "class-selector" est importante pour éviter un cas d'erreur
	 */
	const handleScrollAnimation = () => {
		if (scrollElements) {
			scrollElements.forEach((el: HTMLElement) => {
				if (elementInView(el, 1)) {
					displayScrollElement(el);
				} else if (elementOutofView(el)) {
					hideScrollElement(el);
				}
			});
		}

		if (scrollElementsPres) {
			scrollElementsPres.forEach((el: HTMLElement) => {
				if (elementInView(el, 1)) {
					displayScrollElement(el);
				} else if (elementOutofView(el)) {
					hideScrollElement(el);
				}
			});
		}
	};

	// Event au scroll 🚀
	window.addEventListener(`scroll`, () => {
		handleScrollAnimation();
	});
})();

const waitForElm = (selector: string) => {
	return new Promise((resolve) => {
		if (document.querySelector(selector)) {
			return resolve(document.querySelector(selector));
		}

		const observer = new MutationObserver(() => {
			if (document.querySelector(selector)) {
				resolve(document.querySelector(selector));
				observer.disconnect();
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});
	});
};
